import { phoneNumberMask } from "../utils/input-masks";
import MaskedInput from "react-text-mask";
import { TextField, TextFieldProps } from "./TextField";
import { forwardRef } from "react";

type PhoneNumberTextFieldProps = TextFieldProps;

export const PhoneNumberTextField = forwardRef<
  HTMLInputElement,
  PhoneNumberTextFieldProps
>((props, ref) => {
  return (
    <MaskedInput
      mask={phoneNumberMask}
      render={(maskedRef, maskedInputProps) => (
        <TextField
          {...props}
          name="phoneNumber"
          InputProps={{
            inputRef: maskedRef,
          }}
          inputRef={ref}
          {...maskedInputProps}
        />
      )}
    />
  );
});

PhoneNumberTextField.displayName = "PhoneNumberTextField";
